import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { LessonTypeColor } from "constants/CommonConstants";
import { lessons } from "./LessonSection";
import EnrolledStudentsTab from "./EnrolledStudentsTab";
import Assessment from "./Assessment";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import CourseSchedule from "./CourseSchedule";
import { COURSE_DETAIL_TAB_CONFIG } from "components/constant";

const DEFAULT_COURSE = {
  courseName: { value: "Energy Management Basics" },
  category: { value: "Energy & Utilities" },
  level: { value: "Beginner" },
  courseLanguage: { value: "English" },
  courseDescription: {
    value:
      "Energy Management Basics introduces the fundamental concepts of efficient energy use in organizations and facilities. This course covers key principles such as energy consumption patterns, cost-saving strategies, sustainability practices, and basic monitoring techniques. Learners will gain an understanding of how effective energy management helps reduce operational costs, improve efficiency, and support environmental responsibility.",
  },
  courseStartDate: {
    value: "17 Jan 2026",
    error: "",
  },
  courseEndDate: {
    value: "30 Jan 2026",
  },
  courseRating: {
    value: 4.5,
    error: "",
  },
  preRequisites: { value: "YES" },
  requiredDoc: {
    value: [
      { value: "10th_grade_ssc", label: "10th Grade / SSC" },
      { value: "12th_grade", label: "12th Grade" },
      { value: "diploma_certificate", label: "Diploma Certificate" },
    ],
  },
  certificateEnabled: { value: "YES" },
  courseMedia: { value: true },
  TrainerName: {
    value: "Rahul Sharma, Gokul Patil",
    error: "",
  },
  courseType: {
    value: "Recorded",
    error: "",
  },
  accessType: {
    value: "Paid ",
    error: "",
  },
  price: {
    value: "49.99",
    error: "",
  },
  maxParticipants: {
    value: 50,
    error: "",
  },
  offlineAddress: {
    value: "123, Energy Street, New Delhi",
    error: "",
  },
  totalEnrollment: {
    value: "159",
    error: "",
  },
};

const SectionHeader = ({ title, isOpen, handleOnClick }) => (
  <div className="d-flex  align-items-center cursor" onClick={handleOnClick}>
    <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`} />
    <h5 className="ml-2 mb-0 section-header-title">{title}</h5>
  </div>
);

function CourseDetail() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || "COURSE";
  const config = COURSE_DETAIL_TAB_CONFIG(role, mode);
  const [activeTab, setActiveTab] = useState("details");
  const [openLessonIndex, setOpenLessonIndex] = useState(0);

  const courseData = DEFAULT_COURSE;
  //decode id here from url
  const decodedId = id ? urlDecodedId(id) : null;

  useEffect(() => {
    if (decodedId) {
    }
  }, [decodedId]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveTab(params.get("tab") || "details");
  }, [location.search]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      const params = new URLSearchParams(location.search);
      params.set("tab", tab);

      if (tab === "assessment") {
        params.set("lang", derivedCourseLanguage);
      }
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
        state: { mode }, 
      });
    }
  };

  //common fun to use to display data
  const CourseInfoRow = ({ iconClass, label, value, iconExtraClass = "" }) => {
    if (!value && value !== 0) return null; // skip empty values
    return (
      <div className="mb-2 d-flex align-items-center">
        <i className={`${iconClass} mr-2 text-muted ${iconExtraClass}`} />
        <span className="mr-1">{label} :</span>
        <strong>{value}</strong>
      </div>
    );
  };

  const derivedCourseLanguage =
    decodedId === 1 ? "English" : decodedId === 2 ? "Hindi" : "English, Hindi";

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6 course-layout">
        <Row>
          <Col md="12">
            <div
              className="d-flex align-items-center cursor text-white mb-3"
              onClick={() => navigate(-1)}
            >
              <i className="fa-solid fa-angle-left mr-2" />
              <span className="font-weight-bold">Back</span>
            </div>
            <Card>
              <CardHeader className="pb-0 course-sticky-header">
                <Nav className="custom-tabs cursor">
                  {config.details && (
                    <NavItem>
                      <NavLink
                        className={activeTab === "details" ? "active" : ""}
                        onClick={() => toggleTab("details")}
                      >
                        Course Details
                      </NavLink>
                    </NavItem>
                  )}

                  {config.schedule && (
                    <NavItem>
                      <NavLink
                        className={activeTab === "schedule" ? "active" : ""}
                        onClick={() => toggleTab("schedule")}
                      >
                        Schedule
                      </NavLink>
                    </NavItem>
                  )}

                  {config.assessment && (
                    <NavItem>
                      <NavLink
                        className={activeTab === "assessment" ? "active" : ""}
                        onClick={() => toggleTab("assessment")}
                      >
                        Assessment
                      </NavLink>
                    </NavItem>
                  )}

                  {config.enrollment && (
                    <NavItem>
                      <NavLink
                        className={activeTab === "enrollment" ? "active" : ""}
                        onClick={() => toggleTab("enrollment")}
                      >
                        Enrollment
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
              </CardHeader>
            </Card>
            <TabContent
              activeTab={activeTab}
              className="course-tab-scroll course-details"
            >
              <TabPane className="course-details" tabId="details">
                <Card className="mb-3 ">
                  <CardBody>
                    <Row>
                      <Col md="7" className="d-flex flex-column">
                        <div className="mb-2">
                          <h2 className="text-deep-blue">
                            {courseData.courseName.value}
                          </h2>
                          <span className="mb-4 text-justify pr-5 text-muted">
                            {courseData.courseDescription.value}
                          </span>
                        </div>
                        <div className="mb-2">
                          Price:
                          {courseData.accessType.value.trim().toLowerCase() ===
                          "paid" ? (
                            <span className="price-badge">
                              ₹{courseData.price.value}
                            </span>
                          ) : (
                            <span className="price-badge badge-free">Free</span>
                          )}
                        </div>
                        <div className="mt-auto pt-4 border-top">
                          <Row>
                            <Col md="6">
                              <CourseInfoRow
                                iconClass="fa fa-user-tie"
                                label="Instructor"
                                value={courseData.TrainerName.value}
                              />
                              <CourseInfoRow
                                iconClass="fa-solid fa-chart-simple"
                                label="Level"
                                value={courseData.level.value}
                              />
                              <CourseInfoRow
                                iconClass="fa fa-book"
                                label="Lessons"
                                value={lessons.length}
                              />
                              <CourseInfoRow
                                iconClass="fa fa-globe"
                                label="Language"
                                value={derivedCourseLanguage}
                              />
                            </Col>
                            <Col md="6">
                              <CourseInfoRow
                                iconClass="fa-regular fa-clock"
                                label="Duration"
                                value={`${courseData.courseStartDate.value} – ${courseData.courseEndDate.value}`}
                              />
                              <CourseInfoRow
                                iconClass="fa-solid fa-star"
                                iconExtraClass="star-yellow"
                                label="Rating"
                                value={courseData.courseRating.value}
                              />
                              <CourseInfoRow
                                iconClass="fa fa-video"
                                label="Course Type"
                                value={courseData.courseType.value}
                              />
                              <CourseInfoRow
                                iconClass="fa fa-users"
                                label="Enrollment Count"
                                value={courseData.totalEnrollment.value}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col md="5">
                        {courseData.courseMedia?.value && (
                          <img
                            src={require("../../assets/img/certificates/energy_management.jpg")}
                            alt="Course Media"
                            className="img-fluid rounded"
                          />
                        )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row className="mb-6">
                  <Col md="8">
                    <Card>
                      <CardHeader>
                        <h4 className="mb-0">Lessons</h4>
                      </CardHeader>
                      <CardBody>
                        {lessons.length === 0 ? (
                          <p className="text-muted mb-0">No lessons added</p>
                        ) : (
                          lessons.map((lesson, index) => (
                            <Card key={index} className="mb-2 border">
                              <CardHeader>
                                <SectionHeader
                                  title={lesson.title}
                                  isOpen={openLessonIndex === index}
                                  handleOnClick={() =>
                                    setOpenLessonIndex(
                                      openLessonIndex === index ? null : index,
                                    )
                                  }
                                />
                              </CardHeader>
                              <Collapse isOpen={openLessonIndex === index}>
                                <CardBody>
                                  <div className="d-flex align-items-center mb-2">
                                    <i className="fa-regular fa-clock mr-2 text-muted" />
                                    <span className="mr-1">Duration:</span>
                                    <strong>{lesson.duration}</strong>
                                  </div>
                                  <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-layer-group mr-2 text-muted" />
                                    <span className="mr-2">Type:</span>
                                    <Badge color={LessonTypeColor[lesson.type]}>
                                      {lesson.type}
                                    </Badge>
                                  </div>
                                  {lesson.description && (
                                    <span className="mb-0 mt-2">
                                      {lesson.description}
                                    </span>
                                  )}
                                </CardBody>
                              </Collapse>
                            </Card>
                          ))
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card className="mb-3">
                      <CardHeader>
                        <h4 className="mb-0">Prerequisites</h4>
                      </CardHeader>
                      <CardBody>
                        {courseData.preRequisites.value === "YES" &&
                        courseData.requiredDoc?.value?.length > 0 ? (
                          <ul className="pl-3 mb-0">
                            {courseData.requiredDoc.value.map((doc) => (
                              <li key={doc.value}>{doc.label}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-muted mb-0">
                            No prerequisites defined
                          </p>
                        )}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardHeader>
                        <h4 className="mb-0">Certificate</h4>
                      </CardHeader>
                      <CardBody className="text-center">
                        {courseData.certificateEnabled.value === "YES" ? (
                          <img
                            src={require("../../assets/img/certificates/template1.png")}
                            alt="Certificate"
                            className="img-fluid rounded shadow w-75"
                          />
                        ) : (
                          <p className="text-muted mb-0">Not Available</p>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="schedule">
                <CourseSchedule courseId={decodedId} />
              </TabPane>

              <TabPane tabId="assessment">
                <Row>
                  <Col>
                    <Assessment courseId={decodedId} />
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="enrollment">
                <EnrolledStudentsTab
                  courseName={courseData.courseName.value}
                  trainerName={courseData.TrainerName.value}
                  courseLevel={courseData.level.value}
                  courseType={courseData.courseType.value}
                />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CourseDetail;
